import React from "react";
import styles from "../styles/itemList.module.css";
import Item from "./Item";
import signatureImage from "../sign.jpg";

var numberToText = require("number2text");

function round(num, decimalPlaces = 0) {
  if (num < 0) return -round(-num, decimalPlaces);
  num = Math.round(num + "e" + decimalPlaces);
  return Number(num + "e" + -decimalPlaces);
}

const ItemList = ({ itemList, taxType, taxRate }) => {
  // Calculate total before tax
  let total_discount = itemList.reduce((acc, item) => acc + (parseFloat(item.discount) || 0), 0);
  let total_amount = itemList.reduce((acc, item) => acc + (parseFloat(item.unitPrice) || 0) * (parseFloat(item.quantity) || 0), 0);

  // Calculate tax amount
  const taxAmount = round((total_amount * taxRate) / 100, 2);

  // Calculate grand total
  const grandTotal = round(total_amount + taxAmount, 2);

  return (
    <div className={styles.itemList}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.table__header}>
            <th>Sl. No</th>
            <th>Description</th>
            <th>HSN Code</th>
            <th>Unit Price</th>
            <th>Qty</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {itemList.map((itemDetails, index) => (
            <Item
              key={index}
              sl={index + 1}
              itemDetails={itemDetails}
              taxType={taxType}
              totalDiscount={total_discount}
            />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={5}>Total:</td>
            <td className={styles.totals}>{total_amount.toFixed(2)}</td>
          </tr>
          <tr>
            <td colSpan={5}>Tax ({taxRate}%):</td>
            <td className={styles.totals}>{taxAmount.toFixed(2)}</td>
          </tr>
          <tr>
            <td colSpan={5}><strong>Grand Total:</strong></td>
            <td className={styles.totals}><strong>{grandTotal.toFixed(2)}</strong></td>
          </tr>
          <tr>
            <td colSpan={6}>
              Amount in Words: <span className={styles.words}>{numberToText(grandTotal, "", true)}</span>
            </td>
          </tr>
          <tr>
            <td colSpan={6} className={styles.sign}>
              <span>For cQube:</span>
              <span>
                <img src={signatureImage} alt="Signature" height={50} />
              </span>
              <span>Authorised Signatory</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default ItemList;
